import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import GlobalComponents from './globalComponents'
import './lib/css'
import 'bootstrap';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueI18n from 'vue-i18n'
//language for Vue-I18N
import messages from './lang'
import Paginate from 'vuejs-paginate'
import datePicker from 'vue-bootstrap-datetimepicker'
import VueHtmlToPaper from 'vue-html-to-paper';
// plugins/vue-google-oauth2.js
// file name can be changed to whatever you want
import GAuth from 'vue-google-oauth2'
// import { initFbsdk } from '@/config/facebook_oAuth.js'

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ]
}
Vue.use(VueHtmlToPaper, options);
Vue.use(datePicker)
Vue.component('paginate', Paginate)
Vue.use(VueI18n)
Vue.use(VueToast);
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 5,
  newestOnTop: true
});
// Bootstrap vue
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.config.productionTip = false
// i18n
const i18n = new VueI18n({
  locale: localStorage.locale,
  messages,
  fallbackLocale: 'vi',
})
// Global components
Vue.use(GlobalComponents)
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

const gauthOption = {
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  scope: 'profile email',
  prompt: 'select_account'
}
Vue.use(GAuth, gauthOption)
// Vue.use(initFbsdk())
const app = new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
export default app